import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'

export function RouteNotFound() {
	const { t } = useTranslation()

	return (
		<div className='flex flex-col items-start gap-3 p-6'>
			<h1 className='font-semibold text-lg'>{t('error.not_found_title')}</h1>
			<p className='text-muted-foreground text-sm'>{t('error.not_found_description')}</p>
			<Button asChild variant='outline' size='sm'>
				<Link to='/'>{t('error.back_home')}</Link>
			</Button>
		</div>
	)
}
